module.exports = __webpack_public_path__ + "static/media/1009844.f1deeda3.jpg";